export default {
  addClassAction (context, payload) {
    return new Promise((resolve, reject) => {
      context.commit("addClass", payload)
      resolve()
    })
  }
}
